import FormFieldTags from "components/FormFields/Tags";
import ReadMoreDocsLink from "components/ReadMoreDocsLink";
import TooltipModalBody from "ds/components/TooltipModal/Body";
import { TooltipModalTitle } from "ds/components/TooltipModal/Title";
import { getDocsUrl } from "utils/getDocsUrl";
import { UserManagementActivationStatus } from "views/Account/Settings/types";

import FormFieldManagedUserGroups from "../FormFieldManagedUserGroups";

type FormFieldApiKeyGroupsProps = {
  name: string;
  activationStatus: UserManagementActivationStatus;
  isOptional?: boolean;
};

const FormFieldApiKeyGroups = ({
  name,
  activationStatus,
  isOptional,
}: FormFieldApiKeyGroupsProps) => {
  const isUserManagementActive = activationStatus === UserManagementActivationStatus.ACTIVE;

  if (isUserManagementActive) {
    return <FormFieldManagedUserGroups name={name} label="IdP groups" isOptional={isOptional} />;
  }

  return (
    <FormFieldTags
      label="Groups"
      tagName="group"
      name={name}
      isOptional={isOptional}
      tooltipMode="parent"
      tooltipInfo={
        <>
          <TooltipModalTitle>Groups</TooltipModalTitle>
          <TooltipModalBody align="start">
            By assigning a group to your API key, you offer access to resources on a group/team
            level, rather than individually.
            <ReadMoreDocsLink
              docsUrl={getDocsUrl(
                "/concepts/authorization/assigning-roles-api-keys#assign-roles-to-api-keys-using-idp-groups"
              )}
            />
          </TooltipModalBody>
        </>
      }
      tooltipInfoVariant="modal"
      helperText="Enter the group string defined in your login policy to assign this API key to that group."
    />
  );
};

export default FormFieldApiKeyGroups;
